/**
 * The widget registry (doc 04 · registries #4, `specs/M10-D2-widgets.md` §3).
 *
 * Build order is **usage order**: this account runs 9 chart widgets and 1 battery and nothing
 * else (`specs/M10-D1-dashboards.md` §1), so chart and battery are real, numbers and text are the
 * two that complete an honest set, and every remaining `ExternalWidget` member is registered as a
 * placeholder so an import never loses a widget.
 */
import { widgetRegistry, registerWidget } from './types.js';
import { chartWidget } from './chart/index.js';
import { numbersWidget } from './numbers/index.js';
import { batteryWidget } from './battery/index.js';
import { textWidget } from './text/index.js';
import { PLACEHOLDER_WIDGETS } from './placeholders/index.js';
export * from './types.js';
export * from './chart/index.js';
export * from './numbers/index.js';
export * from './battery/index.js';
export * from './text/index.js';
export * from './placeholders/index.js';
export * from './monday-import.js';
let registered = false;
export function registerBuiltInWidgets() {
    if (registered)
        return;
    registered = true;
    registerWidget(chartWidget);
    registerWidget(numbersWidget);
    registerWidget(batteryWidget);
    registerWidget(textWidget);
    for (const definition of PLACEHOLDER_WIDGETS)
        registerWidget(definition);
}
registerBuiltInWidgets();
/** The kinds the *Add widget* gallery lists, in monday's own gallery order. */
export function galleryWidgets() {
    return widgetRegistry.list().sort((a, b) => a.galleryOrder - b.galleryOrder);
}
/** monday's `ExternalWidget` → our default registry id for it. */
export function widgetIdForKind(kind) {
    const candidates = widgetRegistry.list().filter((definition) => definition.kind === kind);
    // `APP_FEATURE` covers a family (§3.1); the generic app host is its default.
    if (kind === 'APP_FEATURE')
        return candidates.find((definition) => definition.id === 'app')?.id;
    return (candidates.find((definition) => definition.implemented) ?? candidates[0])?.id;
}
export { widgetRegistry };
//# sourceMappingURL=index.js.map